// Central navigation + visibility config.
// `hidden_nav` (array of ids) is stored in website settings and toggled from the admin panel.

export const HEADER_NAV = [
  { id: "home", label: "Home", to: "/", locked: true },
  { id: "about", label: "About", to: "/about" },
  { id: "mission-vision", label: "Mission & Vision", to: "/mission-vision" },
  { id: "leadership", label: "Leadership", to: "/leadership" },
  { id: "our-work", label: "Our Work", to: "/our-work" },
  { id: "pil", label: "Public Interest Litigations", to: "/pil" },
  { id: "issues", label: "Under the Lens", to: "/issues" },
  { id: "media", label: "Media", to: "/media" },
  { id: "documents", label: "Documents", to: "/documents" },
  { id: "official-documents", label: "Official Documents", to: "/official-documents" },
  { id: "contact", label: "Contact", to: "/contact" },
  { id: "donate", label: "Donate", to: "/donate" },
];

export const POLICY_LINKS = [
  { id: "privacy", label: "Privacy Policy", to: "/privacy" },
  { id: "terms", label: "Terms & Conditions", to: "/terms" },
  { id: "refund-policy", label: "Refund Policy", to: "/refund-policy" },
  { id: "disclaimer", label: "Disclaimer", to: "/disclaimer" },
];

// Text blocks / whole sections that can be shown or hidden.
export const TEXT_BLOCKS = [
  { id: "header-topbar", label: "Header top bar (tagline + email)" },
  { id: "footer-intro", label: "Footer intro paragraph" },
  { id: "footer-quicklinks", label: "Footer — Quick Links column" },
  { id: "footer-policies", label: "Footer — Policies column" },
  { id: "footer-contact", label: "Footer — Contact column" },
];

// Homepage statistics that can be individually hidden (stored in settings.hidden_stats).
export const STAT_ITEMS = [
  { id: "pils", label: "Public Interest Litigations" },
  { id: "orders", label: "Court Orders Archived" },
  { id: "public_representations", label: "Public Representations" },
  { id: "areas_of_intervention", label: "Areas of Intervention" },
  { id: "media_coverage", label: "Media Coverage" },
  { id: "documents", label: "Public Documents" },
  { id: "press_releases", label: "Press Releases" },
];

export const isStatHidden = (settings, id) => Array.isArray(settings?.hidden_stats) && settings.hidden_stats.includes(id);

// Groups shown in the admin visibility manager.
export const VISIBILITY_GROUPS = [
  { title: "Pages (header & footer)", items: HEADER_NAV.filter((n) => !n.locked) },
  { title: "Policy pages (footer)", items: POLICY_LINKS },
  { title: "Header & footer text", items: TEXT_BLOCKS },
];

// Route prefixes that map to a hideable page id (used to block direct navigation).
const PATH_MAP = [
  { prefix: "/about", id: "about" },
  { prefix: "/mission-vision", id: "mission-vision" },
  { prefix: "/leadership", id: "leadership" },
  { prefix: "/our-work", id: "our-work" },
  { prefix: "/initiatives", id: "our-work" },
  { prefix: "/pil", id: "pil" },
  { prefix: "/issues", id: "issues" },
  { prefix: "/media", id: "media" },
  { prefix: "/documents", id: "documents" },
  { prefix: "/official-documents", id: "official-documents" },
  { prefix: "/contact", id: "contact" },
  { prefix: "/donate", id: "donate" },
  { prefix: "/privacy", id: "privacy" },
  { prefix: "/terms", id: "terms" },
  { prefix: "/refund-policy", id: "refund-policy" },
  { prefix: "/disclaimer", id: "disclaimer" },
];

export function pathToNavId(pathname) {
  const match = PATH_MAP.find((m) => pathname === m.prefix || pathname.startsWith(m.prefix + "/"));
  return match ? match.id : null;
}

export function isHidden(settings, id) {
  return Array.isArray(settings?.hidden_nav) && settings.hidden_nav.includes(id);
}
